import { Routes } from '@angular/router';

// dashboard
import { IndexComponent } from './index';

// layouts
import { AppLayout } from './layouts/app-layout';
import { AuthLayout } from './layouts/auth-layout';

// AuthGuard
import { AuthGuard } from './guards/auth.guard';

// merchants
import { MerchantsComponent } from './pages/merchants/merchants.component';
import { MerchantFormComponent } from './pages/merchants/merchant-form/merchant-form.component';

// providers
import { ProvidersComponent } from './pages/providers/providers.component';
import { ProviderFormComponent } from './pages/providers/provider-form/provider-form.component';

// merchant product
import { MerchantProductsComponent } from './pages/merchantProducts/merchantProducts.component';
import { MerchantProductFormComponent } from './pages/merchantProducts/merchantProduct-form/merchantProduct-form.component'; // merchant product
import { ProductsComponent } from './pages/products/products.component';
import { ProductFormComponent } from './pages/products/product-form/product-form.component'; // transactions
import { TransactionsComponent } from './pages/transactions/transactions.component'; // transactions
import { TransactionDetailsComponent } from './pages/transactionDetails/transactionDetails.component'; // transactions
import { DepositsComponent } from './pages/deposits/deposits.component';
import { DepositFormComponent } from './pages/deposits/deposit-form/deposit-form.component'; // categories
import { CategoriesComponent } from './pages/categories/categories.component';
import { CategoriesFormComponent } from './pages/categories/categories-form/categories-form.component';
import { ReconComponent } from './pages/recon/recon.component';
import { VirtualAccountsComponent } from './pages/virtualAccounts/virtualAccounts.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      // dashboard
      {
        path: '',
        component: IndexComponent,
        title: 'Dashboard Admin | Kilat Teknolgi Mandiri',
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'analytics',
      //   component: AnalyticsComponent,
      //   title: 'Analytics Admin | Kilat Teknolgi Mandiri',
      //   canActivate: [AuthGuard],
      // },
      // //apps
      // { path: '', loadChildren: () => import('./apps/apps.module').then((d) => d.AppsModule) },

      // components
      { path: '', loadChildren: () => import('./components/components.module').then((d) => d.ComponentsModule) },

      // elements
      { path: '', loadChildren: () => import('./elements/elements.module').then((d) => d.ElementsModule) },

      // forms
      { path: '', loadChildren: () => import('./forms/form.module').then((d) => d.FormModule) },

      // users
      { path: '', loadChildren: () => import('./users/user.module').then((d) => d.UsersModule) },

      { path: '', loadChildren: () => import('./datatables/datatables.module').then((d) => d.DatatablesModule) },
    ],
  },

  {
    path: '',
    component: AuthLayout,
    children: [
      // pages
      { path: '', loadChildren: () => import('./pages/pages.module').then((d) => d.PagesModule) },

      // auth
      { path: '', loadChildren: () => import('./auth/auth.module').then((d) => d.AuthModule) },
    ],
  },

  {
    path: 'users',
    component: AppLayout,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then((d) => d.PagesModule),
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'categories',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: CategoriesComponent,
        title: 'Category | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'new',
        component: CategoriesFormComponent,
        title: 'Create Category | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'edit/:id',
        component: CategoriesFormComponent,
        title: 'Edit Category | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'merchants',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: MerchantsComponent,
        title: 'Merchant | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'new',
        component: MerchantFormComponent,
        title: 'Create Merchant | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'edit/:id',
        component: MerchantFormComponent,
        title: 'Edit Merchant | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'providers',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: ProvidersComponent,
        title: 'Provider | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'new',
        component: ProviderFormComponent,
        title: 'Create Provider | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'edit/:id',
        component: ProviderFormComponent,
        title: 'Edit Provider | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'merchant-products',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: MerchantProductsComponent,
        title: 'Merchant Product | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'new',
        component: MerchantProductFormComponent,
        title: 'Create Merchant Product | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'edit/:id',
        component: MerchantProductFormComponent,
        title: 'Edit Merchant Product | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'transactions',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: TransactionsComponent,
        title: 'Transactions | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'transaction-details',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: TransactionDetailsComponent,
        title: 'Transaction Details | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'virtual-accounts',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: VirtualAccountsComponent,
        title: 'Virtual Accounts | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'deposits',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: DepositsComponent,
        title: 'Deposits | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'new',
        component: DepositFormComponent,
        title: 'Create Deposit | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'edit/:id',
        component: DepositFormComponent,
        title: 'Edit Deposit | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'products',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: ProductsComponent,
        title: 'Products | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'new',
        component: ProductFormComponent,
        title: 'Create Product | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
      {
        path: 'edit/:id',
        component: ProductFormComponent,
        title: 'Edit Product | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  {
    path: 'recons',
    component: AppLayout,
    children: [
      {
        path: 'list',
        component: ReconComponent,
        title: 'Recons | Kilat Teknolgi Mandiri ',
        canActivate: [AuthGuard],
      },
    ],
  },

  { path: '**', redirectTo: 'auth/login' },
];
